import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProjectRoutingModule } from './project-routing.module';
import { ProjectCreateComponent } from './project-create/project-create.component';
import { ProjectEditComponent } from './project-edit/project-edit.component';
import { ProjectViewComponent } from './project-view/project-view.component';
import { ProjectListComponent } from './project-list/project-list.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgSelectModule } from '@ng-select/ng-select';
import { ProductAuditComponent } from './product-audit/product-audit.component';
import { ContractAuditComponent } from './contract-audit/contract-audit.component';

@NgModule({
  declarations: [
    ProjectCreateComponent,
    ProjectEditComponent,
    ProjectViewComponent,
    ProjectListComponent,
    ProductAuditComponent,
    ContractAuditComponent
  ],
  imports: [
    CommonModule,
    ProjectRoutingModule,
    NgxDatatableModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    NgSelectModule,
    
  ]
})
export class ProjectModule { }
